var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_55969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6052 20C38.6052 30.2752 30.2755 38.6048 20.0003 38.6048C9.72518 38.6048 1.39551 30.2752 1.39551 20C1.39551 9.72481 9.72518 1.39514 20.0003 1.39514C30.2755 1.39514 38.6052 9.72481 38.6052 20Z",
    fill: "white",
    stroke: "#6F525C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8918 20.0551C22.8918 20.4503 22.7405 20.8455 22.438 21.1481L12.962 30.6241C12.3568 31.2292 11.381 31.2292 10.7761 30.6241C10.171 30.0191 10.171 29.0432 10.7761 28.4429L19.1639 20.0551L10.7761 11.6672C10.171 11.0621 10.171 10.0862 10.7761 9.48605C11.3812 8.88095 12.3571 8.88095 12.962 9.48605L22.438 18.962C22.7406 19.2646 22.8918 19.6598 22.8918 20.0551Z",
    fill: "#706A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3185 20.0551C31.3185 20.4503 31.1673 20.8455 30.8648 21.1481L21.3888 30.6241C20.7837 31.2292 19.8078 31.2292 19.2029 30.6241C18.5977 30.0191 18.5977 29.0432 19.2029 28.4429L27.5908 20.0551L19.2029 11.6672C18.5977 11.0621 18.5977 10.0862 19.2029 9.48605C19.8079 8.88095 20.7838 8.88095 21.3888 9.48605L30.8648 18.962C31.1674 19.2646 31.3185 19.6598 31.3185 20.0551Z",
    fill: "#706A85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_55969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrow-next.41e9266413970fba27c66b080497231e.svg";
export { ForwardRef as ReactComponent };